import React from 'react';
import '../css/about.css';
import FadeInSection from '../components/FadeInSection';

const VALUES = ['✦ Creativity', '⚡ Innovation', '💎 Professionalism', '🤝 Transparency', '🎯 Quality First', '🚀 Client Success'];

export default function About() {
  return (
    <div className="about">
      <FadeInSection direction="up">
      <section className="about-hero">
        <div className="container">
          <span className="section-tag">Who We Are</span>
          <h1>About AMKO Agency</h1>
          <p className="section-sub">A creative marketing, branding, and event management agency based in Erbil.</p>
        </div>
      </section>
      </FadeInSection>

      <FadeInSection direction="left">
      <section className="section section-white">
        <div className="container">
          <div className="about-grid">
            <div className="about-text">
              <p>AMKO Agency combines creativity, technology, and market insight to deliver modern branding experiences that connect businesses with their audiences.</p>
              <p>We work with startups, NGOs, corporate businesses, restaurants, retail brands, and entrepreneurs across Erbil and the Kurdistan region.</p>
              <p><strong>Vision —</strong> To become one of the leading creative agencies in Iraq and the Middle East.</p>
              <p><strong>Mission —</strong> Empowering businesses through strategic branding, creative storytelling, and digital transformation.</p>
              <div className="values-grid">
                {VALUES.map(v => <div key={v} className="value-tag">{v}</div>)}
              </div>
            </div>
            <div className="about-card">
              <div className="about-stat">5+</div>
              <div className="about-stat-label">Years creating impact in Erbil</div>
              {['Creative Marketing Agency', 'Event Management Experts', 'Brand Identity Specialists', 'Digital Solutions Provider', 'Media Production House'].map(t => (
                <div key={t} className="about-item">
                  <span className="dot" />
                  {t}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      </FadeInSection>
    </div>
  );
}
